<template>
  <v-dialog
    transition="dialog-top-transition"
    class="save-dashboard"
    width="600"
    v-model="visible"
    persistent
  >
    <template v-slot:default="{ isActive }">
      <v-card>
        <v-card-title class="d-flex align-center justify-between">
          <v-spacer></v-spacer>
          <v-btn
            @click="close"
            flat
            icon
            class="chart-preview-close-btn"
            size="x-small"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </v-card-title>
        <v-card-text class="mt-4 mx-5">
          <h6 class="text-center">Download limit reached</h6>
          <p class="text-center">{{ message }}</p>
        </v-card-text>
        <v-card-actions class="btn-wrap">
          <v-btn class="cancel-btn" @click="isActive.value = false">
            <span>Cancel</span>
          </v-btn>
          <v-btn class="primary-btn" @click="sendEmail">
            <span>Email</span>
          </v-btn>
        </v-card-actions>
      </v-card>
    </template>
  </v-dialog>
</template>

<script>
import { eventBus } from "@/eventBus";
import { openDownloadLimitEmail } from "@/utils/sampleReportDownload";

export default {
  name: "DownloadLimitModal",
  data() {
    return {
      visible: false,
      message: "",
    };
  },
  mounted() {
    eventBus.on("showDownloadLimitModal", this.onShow);
  },
  beforeUnmount() {
    eventBus.off("showDownloadLimitModal", this.onShow);
  },
  methods: {
    onShow(payload) {
      this.message =
        payload?.message ||
        "The download limit for your account has been exceeded. Please contact the administrator at amemon@fluidsdata.com to request an increase in your download limit.";
      this.visible = true;
    },
    close() {
      this.visible = false;
    },
    sendEmail() {
      openDownloadLimitEmail();
      this.close();
    },
  },
};
</script>
